import { Root, List, Trigger } from "@radix-ui/react-tabs";
import { useEffect, useState } from "react";
import type { TabCardProps } from "@op/puck-types";
import { Dc_Card_Tabs, ToggleGroup } from "@op/sf-op";
import { clx, slug } from "@op/utils";
import TabCardItem from "../../../../../components/puck/TabCardItem/TabCardItem";
import { LazyIcon } from "@op/icons";

const TabCard = ({ items }: TabCardProps) => {
  const [viewport, setViewport] = useState<"mobile" | "desktop">("desktop");

  function onResize() {
    if (window.innerWidth < 768) {
      setViewport("mobile");
    } else {
      setViewport("desktop");
    }
  }

  useEffect(() => {
    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const [currentValue, setCurrentValue] = useState<string | undefined>(
    items[0]?.title ? slug(items[0]?.title) : undefined
  );

  function onValueChange(value: string) {
    setCurrentValue(value);
  }

  return (
    <Root value={currentValue} onValueChange={onValueChange} className="w-full">
      <Dc_Card_Tabs
        tabs={
          <ToggleGroup
            orientation={viewport === "mobile" ? "vertical" : "horizontal"}
            value={currentValue}
          >
            <List>
              {items.map((item, index) => {
                const { title, icon } = item;
                const value = slug(title);
                return (
                  <Trigger
                    key={`${value}-${index}`}
                    value={value}
                    className={clx({
                      "w-full": viewport === "mobile",
                    })}
                  >
                    <ToggleGroup.Item
                      value={value}
                      icon={icon && <LazyIcon icon={icon} />}
                    >
                      {title}
                    </ToggleGroup.Item>
                  </Trigger>
                );
              })}
            </List>
          </ToggleGroup>
        }
      >
        {items.map((item, idx) => (
          <TabCardItem key={`${item.title}-${idx}`} {...item} />
        ))}
      </Dc_Card_Tabs>
    </Root>
  );
};

export default TabCard;
